export const passosSubmodalidades = [
  {
    numero: 1,
    titulo: "Escolher Experiência",
    descricao: "Identifique uma experiência negativa que deseja transformar e uma experiência de recurso positivo",
    icone: "ri-focus-3-line",
    cor: "from-purple-500 to-pink-500"
  },
  {
    numero: 2,
    titulo: "Mapear Submodalidades Visuais",
    descricao: "Observe brilho, tamanho, distância, cor, nitidez e movimento da imagem mental",
    icone: "ri-eye-line",
    cor: "from-blue-500 to-cyan-500"
  },
  {
    numero: 3,
    titulo: "Mapear Submodalidades Auditivas",
    descricao: "Perceba volume, tom, ritmo e localização dos sons internos associados",
    icone: "ri-volume-up-line",
    cor: "from-green-500 to-emerald-500"
  },
  {
    numero: 4,
    titulo: "Mapear Submodalidades Cinestésicas",
    descricao: "Sinta temperatura, pressão, intensidade e localização corporal das sensações",
    icone: "ri-hand-heart-line",
    cor: "from-orange-500 to-red-500"
  },
  {
    numero: 5,
    titulo: "Identificar Drivers Críticos",
    descricao: "Descubra quais submodalidades têm maior impacto emocional ao serem alteradas",
    icone: "ri-flashlight-line",
    cor: "from-yellow-500 to-orange-500"
  },
  {
    numero: 6,
    titulo: "Alterar Submodalidades",
    descricao: "Modifique conscientemente as qualidades da experiência negativa",
    icone: "ri-settings-3-line",
    cor: "from-indigo-500 to-purple-500"
  },
  {
    numero: 7,
    titulo: "Técnica Mapping Across",
    descricao: "Transfira as submodalidades da experiência positiva para a negativa",
    icone: "ri-arrow-left-right-line",
    cor: "from-pink-500 to-rose-500"
  },
  {
    numero: 8,
    titulo: "Testar Resultado",
    descricao: "Verifique como você se sente agora ao pensar na experiência original",
    icone: "ri-checkbox-circle-line",
    cor: "from-teal-500 to-green-500"
  }
];

export const submodalidadesVisuais = [
  { nome: "Brilho", descricao: "Quão clara ou escura é a imagem", min: "Escuro", max: "Brilhante" },
  { nome: "Tamanho", descricao: "Tamanho da imagem mental", min: "Pequeno", max: "Grande" },
  { nome: "Distância", descricao: "Quão perto ou longe está a imagem", min: "Longe", max: "Perto" },
  { nome: "Cor/P&B", descricao: "Colorido ou preto e branco", min: "P&B", max: "Colorido" },
  { nome: "Nitidez", descricao: "Clareza e definição da imagem", min: "Desfocado", max: "Nítido" },
  { nome: "Movimento", descricao: "Imagem estática ou em movimento", min: "Estático", max: "Movimento" }
];

export const submodalidadesAuditivas = [
  { nome: "Volume", descricao: "Intensidade do som", min: "Baixo", max: "Alto" },
  { nome: "Tom", descricao: "Grave ou agudo", min: "Grave", max: "Agudo" },
  { nome: "Ritmo", descricao: "Velocidade do som", min: "Lento", max: "Rápido" },
  { nome: "Localização", descricao: "De onde vem o som", min: "Longe", max: "Perto" }
];

export const submodalidadesCinestesicas = [
  { nome: "Temperatura", descricao: "Sensação de calor ou frio", min: "Frio", max: "Quente" },
  { nome: "Pressão", descricao: "Intensidade da pressão física", min: "Leve", max: "Forte" },
  { nome: "Intensidade", descricao: "Força da sensação", min: "Fraca", max: "Intensa" },
  { nome: "Localização", descricao: "Onde no corpo você sente", min: "Difusa", max: "Específica" }
];

export const exemplosExperiencias = [
  {
    negativa: "Ansiedade antes de apresentações",
    positiva: "Confiança ao conversar com amigos próximos"
  },
  {
    negativa: "Medo de rejeição em relacionamentos",
    positiva: "Segurança ao estar com família"
  },
  {
    negativa: "Procrastinação ao iniciar projetos",
    positiva: "Empolgação ao fazer hobbies favoritos"
  },
  {
    negativa: "Insegurança ao tomar decisões importantes",
    positiva: "Clareza ao escolher o que comer"
  },
  {
    negativa: "Frustração com críticas no trabalho",
    positiva: "Gratidão ao receber elogios sinceros"
  }
];

export const dicasSubmodalidades = [
  "Pequenas mudanças nas submodalidades podem gerar grandes transformações emocionais",
  "Os drivers críticos são únicos para cada pessoa - experimente para descobrir os seus",
  "Trabalhe com uma experiência de cada vez para resultados mais eficazes",
  "A técnica Mapping Across é mais poderosa quando feita rapidamente",
  "Se uma mudança não funcionar, volte ao original e tente outra submodalidade",
  "Submodalidades visuais tendem a ser as mais impactantes para a maioria das pessoas",
  "Pratique primeiro com experiências leves antes de trabalhar com memórias intensas",
  "Anote quais submodalidades funcionam melhor para você usar no futuro",
  "A localização corporal das sensações é frequentemente um driver crítico poderoso",
  "Combine alterações de múltiplas submodalidades para resultados mais profundos"
];

export const perguntasPoderosas = [
  "Se você pudesse ajustar os 'controles' dessa experiência, o que mudaria primeiro?",
  "Como seria se essa imagem estivesse mais longe e menor?",
  "E se o som interno fosse mais suave e distante?",
  "O que acontece se você mover a sensação para outra parte do corpo?",
  "Como você se sentiria se essa imagem fosse em preto e branco?",
  "E se você aumentasse o brilho da experiência positiva?",
  "O que muda quando você torna a imagem negativa desfocada?",
  "Como seria se o tom da voz interna fosse mais grave e calmo?"
];